import React, { useState } from 'react'
import CustomInput from 'Common/CustomInput/CustomInput'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import InsurancePlanSuperSearch from 'Components/InsurancePlanSuperSearch/InsurancePlanSuperSearch'
import PatientSuperSearch from 'NewComponents/UtilityComponents/PatientSuperSearch/PatientSuperSearch'
import ParamListGen from 'Services/ParamListGen'
import ExportExcel from 'Components/ExportExcel/ExportExcel'
import CreateTaskPopup from 'MainTabs/Tasks/Taskpopups/CreateTaskPopup'
import AddNewTagPopup from 'Popups/AddNewTagPopup/AddNewTagPopup'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import AsyncSelect from 'Common/AsyncSelect/AsyncSelect'
import PlusIcon from 'SVGS/PlusIcon'
import SuperAccordion from 'Components/SuperAccordion/SuperAccordion'
import FilterSearch from 'Components/FilterSearch/FilterSearch'
import { Tooltip } from 'react-tooltip'
import Show from 'Components/Show/Show'
import Dropdown from 'Common/DropDown/Dropdown'

const ChargesSearchForm = ({
    handleChange,
    searchModel,
    handleSelectedData,
    superSearchValue,
    setsuperSearchValue,
    validationModel,
    paramModel,
    handleClear,
    handleSubmit,
    handleAddNew,
    activeTab,
    subTabs,
    selectedRows,
    taskRowsData,
    filterCount,
    superSearchPayerValue,
    setSuperSearchPayerValue,
    visitLoader,
    handleFilterSuperSearch,
    superVisitValue,
    parentName,
    openDeletedVisitConfirmationPopup

}) => {
    const [taskPopup, setTaskPopup] = useState(false)
    const [tagPopup, setTagPopup] = useState(false)
    const [activeElement, setActiveElement] = useState(null);
    // ***************************** CreateTaskPopup Function Start ***************
    const openTaskPopup = (row) => { setTaskPopup(true) };
    const closeTaskPopup = (row) => { setTaskPopup(false) };
    // ***************************** CreateTaskPopup Function End *****************

    // ********************* TagPopup Function Start ****************
    const closeTagPopup = () => { setTagPopup(false) }
    const openTagPopup = () => { setTagPopup(true) }
    // ********************* TagPopup Function End ****************

    // **************************** SuperAccordion Functions Start ****************************
    const handleToggle = (element) => {
        if (activeElement === element) {
            setActiveElement(null); // Close the accordion
        } else {
            setActiveElement(element); // Open the accordion 
        }
    };
    // **************************** SuperAccordion Functions END ****************************
    return (
        <>
            {taskPopup && <CreateTaskPopup onClose={closeTaskPopup} patientInfo={null}
                claimInfo={taskRowsData}
            />}
            {tagPopup && <AddNewTagPopup onClose={closeTagPopup} tagId={0} allowActive={false} />}
            <Tooltip id={"chargesSearchForm"} style={{ maxWidth: 300, zIndex: 12 }} />
            <div className="mb-4" id='chargesSearchForm'>
                <div className="flex justify-between">
                    <div data-tooltip-id={"ChargesSearchForm"} data-tooltip-content="Only number values are allowed" className="flex items-center w-[355px]  ">
                        <FilterSearch
                            filterCount={filterCount}
                            activeElement={activeElement}
                            handleToggle={handleToggle}
                            loading={visitLoader}
                            handleFilterSuperSearch={handleFilterSuperSearch}
                            superSearchValue={superVisitValue}
                            placeholder='Search Claims...'
                            isNumeric
                        />

                    </div>
                    {parentName !== "tasks" && <div className="flex gap-4">
                        {[...selectedRows].length > 0 ? (
                            <div className='flex items-center justify-end col-span-3 mr-2 border-b'>
                                <div className=''>
                                <Dropdown>
  <Dropdown.Button>
    <button className="pt-2 pb-2 pl-5 pr-5 text-sm text-white rounded-md bg-primary">
      <div className="flex flex-row items-center justify-center">
        Actions
        <span className="text-lg">
          <img src="/img/arrowDown_white.svg" alt="arrow" className="ml-1" />
        </span>
      </div>
    </button>
  </Dropdown.Button>

  <Dropdown.Menu className="dropDownShadow dropdownMain">
    <Dropdown.MenuItem className="dropdownItem" onClick={openTagPopup}>
      Add Tag
    </Dropdown.MenuItem>

    <Dropdown.MenuItem className="dropdownItem" onClick={openTaskPopup}>
      Create Task
    </Dropdown.MenuItem>

    <Dropdown.MenuItem className="dropdownItem">
      Update Status
    </Dropdown.MenuItem>

    <Show when={searchModel.claimStatusCode === "N" || searchModel.claimStatusCode === "B_PAT"}>
      <Dropdown.MenuItem
        className="dropdownItem"
        onClick={openDeletedVisitConfirmationPopup}
      >
        Delete Claims
      </Dropdown.MenuItem>
    </Show>
  </Dropdown.Menu>
</Dropdown>
                                </div>
                            </div>
                        ) : null}
                        <ExportExcel model={{ ...paramModel, isExportCall: true, param_list: ParamListGen(searchModel), }}
                            API={`${process.env.REACT_APP_TC_PMS}/api/Visit/FindVisit`}
                            fileName="Charges Report"
                            subHeading="Are you sure you want to download the Claim Report?"
                        />
                        {(parentName === "ChargesSearch" && activeTab === subTabs[0].key) && <CustomButtonNew prefixIcon={<PlusIcon />} label="Add Claim" onClick={() => handleAddNew(subTabs[1].key)} />}
                    </div>}
                </div>
                <SuperAccordion show={activeElement === 0}>
                    <div className="grid grid-cols-12 gap-4 pt-8 pb-4" >
                        {/* <div className="col-span-2">
                            <CustomInput onChange={handleChange} value={searchModel.visitId} onKeyPress={handleEnter} isNumeric name="visitId" label="Claim #" />
                        </div> */}
                        {
                            (parentName === "ChargesSearch" || parentName === "tasks") && (
                                <div className="col-span-12 md:col-span-2">
                                    <PatientSuperSearch
                                        label="Patient"
                                        searchValue={superSearchValue}
                                        onChange={(value) => setsuperSearchValue(value)}
                                        handleSelectedData={(value) => handleSelectedData(value, "Patient")}
                                        width='100%'
                                    />
                                </div>
                            )
                        }

                        <div className="col-span-12 md:col-span-2">
                            <InsurancePlanSuperSearch
                                label="Payer Name"
                                searchValue={superSearchPayerValue}
                                onChange={(value) => setSuperSearchPayerValue(value)}
                                handleSelectedData={(value) => handleSelectedData(value, "Insurance")}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-2">
                            <CustomSelect value={searchModel.visitType} name="visitType" onChange={handleChange} label="Claim Type"   >
                                <option value="P">Professional</option>
                            </CustomSelect>
                        </div>
                        <div className="col-span-12 md:col-span-2">
                            <AsyncSelect
                                value={searchModel.locationId}
                                name="locationId"
                                onChange={handleChange}
                                label="Locations"
                                apiLink={`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindLocations`}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-2">
                            <AsyncSelect
                                value={searchModel.posCode}
                                name="posCode"
                                onChange={handleChange}
                                label="Place Of Service"
                                apiLink={`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindPOS`}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-2">
                            <CustomSelect value={searchModel.entryDateType} name="entryDateType" onChange={handleChange} label="Date Type">
                                <option value="dateOfEntry">Date of Entry</option>
                                <option value="dateOfSubmission">Date of Submission</option>
                                <option value="DateOfService">Date of Service</option>
                            </CustomSelect>
                        </div>
                        {searchModel.entryDateType === "dateOfEntry" ? (
                            <>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput onChange={handleChange} value={searchModel.entryDateFrom} type="date" name="entryDateFrom" label="Entry Date From" />
                                    {validationModel.entryDateFromError}
                                </div>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput onChange={handleChange} value={searchModel.entryDateTo} type="date" name="entryDateTo" label="Entry Date To" />
                                </div>
                            </>

                        ) : searchModel.entryDateType === "DateOfService" ? (
                            <>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput onChange={handleChange} value={searchModel.dosFrom} type="date" name="dosFrom" label="DOS From" />
                                    {validationModel.dosFromError}
                                </div>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput onChange={handleChange} value={searchModel.dosTo} type="date" name="dosTo" label="DOS To" />
                                </div>
                            </>

                        ) : (
                            <>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput onChange={handleChange} value={searchModel.SubmittedDateFrom} type="date" name="SubmittedDateFrom" label="Date Of Submission From" />
                                    {validationModel.SubmittedDateFromError}
                                </div>
                                <div className="col-span-12 md:col-span-2">
                                    <CustomInput onChange={handleChange} value={searchModel.SubmittedDateTo} type="date" name="SubmittedDateTo" label="Date Of Submission To" />
                                </div>
                            </>
                        )}
                        <div className='col-span-12'>
                            <div className='flex items-end justify-end col-span-4 gap-2 md:col-span-6 xl:col-span-2'>
                                <CustomButtonNew variant="outline" onClick={handleClear} label="Clear" />
                                <CustomButtonNew onClick={() => handleSubmit()} label="Search" />
                            </div>
                        </div>
                    </div>
                </SuperAccordion>
            </div>
        </>
    )
}

export default ChargesSearchForm
